import createAPI from '../createAPI';

const api = createAPI();

export default api;
